<template>
    <div>
        <div v-if="!returnLoadingState" class="footer-financiar">
            <div class="inner-footer-financiar container">
                <div class="copy-right">
                <span><span
                    style="font-weight: bold">&copy; 2019 FINANCIAR.</span> Todos los derechos reservados.</span>
                </div>
                <div class="footer-contact-column">
                        <span style="font-weight: bold">Contacto</span><br>
                            E-mail:  contacto@financiaremprende.com<br>
                            Tel: +54 9 342 5040096<br>
                            (3000) Santa Fe<br>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    export default {
        computed: {
            ...mapGetters(['returnLoadingState'])
        }
    }
</script>

<style scoped lang="scss">
    .footer-financiar {
        background-image: url('~@/assets/img/footer/footer-background.png');
        @include sm-medium() {
            background-image: url('~@/assets/img/footer/footer-background-mobile.png');
        }
        width: 100%;
        height: 300px;
        padding-top: 55px;
        background-size: cover;
        display: flex;
        align-items: center;
        @include xl() {
            height: 200px;
        }
        .inner-footer-financiar {
            display: flex;
            align-items: center;
            justify-content: space-around;
            .copy-right {
                border-top: 3px solid rgba(126, 172, 250, .6);
                padding-top: 10px;
                margin-top: 5%;
                span {
                    color: #4285F4;
                    font-size: 12px;
                }
                @include sm() {
                    display: none;
                }
            }
            .footer-contact-column {
                span {
                    color: #4285F4;
                    font-weight: 300;
                    line-height: 20px;
                }
                @include sm() {
                    text-align: center;
                }
            }
        }
    }
</style>
